import { render, staticRenderFns } from "./bandsForm.vue?vue&type=template&id=2aa22408&scoped=true"
import script from "./bandsForm.vue?vue&type=script&lang=js"
export * from "./bandsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa22408",
  null
  
)

export default component.exports